export default __webpack_public_path__ + "assets/fonts/a687053040639aaf24cb4ef99de65c5b.woff";